import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Modal,
    Grid,
    Header,
    Icon,
    Image,
    Button,
    Label,
    GridRow,
    GridColumn,
} from 'semantic-ui-react';
import { find } from 'lodash';
import { formatMoney, isAdmin } from '../../constants/utils';
import moneyImage from '../../assets/money.svg';
import NumberIncrementor from '../numberIncrementor/NumberIncrementor';
import {
    incrementQuantity,
    decrementQuantity,
    initOrderQuantity,
    saveOrderQuantity,
    addToCart,
    incrementGameQuantityForOrder,
    decrementGameQuantityForOrder,
    addToOrder,
} from '../../redux/actions';
import './styles.css';
import './text-center.css';
import { OUT_OF_STOCK_HIGHLIGHT_NAME } from '../gameCatalogCard/GameCatalogCard';
import { gameDetailModalHighlightStyle } from '../gameCatalog/GameCatalog';
import QuantityActionWrapper from './QuantityActionWrapper';

export class GameCatalogDetailModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            windowWidth: window.innerWidth,
        };
    }

    handleAddToCart = () => {
        const { addToCart, orderQty } = this.props;
        if (orderQty >= 0) {
            addToCart();
            this.handleClose();
        }
    };

    handleClose = () => {
        const { onClose, initOrderQuantity } = this.props;

        onClose();
        initOrderQuantity();
    };

    handleMount = () => {
        const { gameInCart, saveOrderQuantity } = this.props;
        if (!!gameInCart) {
            saveOrderQuantity(gameInCart);
        }
    };
    updateWindowWidth = () => {
        this.setState({ windowWidth: window.innerWidth });
    };

    componentDidMount() {
        window.addEventListener('resize', this.updateWindowWidth);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowWidth);
    }

    render() {
        const {
            game,
            gameInCart,
            isOpen,
            incrementQuantity,
            decrementQuantity,
            orderQty,
            localizeDetail,
            gameInCartQty,
            readOnly,
            isInstantTicket,
            isEditOrder,
            impersonateRetailer,
            isdisplayPrizeLevelsOnItemDetails,
        } = this.props;
        const { windowWidth } = this.state;
        const prizeStructure = Array.isArray(game && game.prizeStructure)
            ? game?.prizeStructure
            : [];

        const showQuantity =
            (readOnly || impersonateRetailer) &&
            game?.highlightName !== OUT_OF_STOCK_HIGHLIGHT_NAME;
        const showDetail =
            !readOnly &&
            !impersonateRetailer &&
            game?.highlightName !== OUT_OF_STOCK_HIGHLIGHT_NAME;
        const showSuggestedQty = isInstantTicket && (impersonateRetailer || !readOnly);
        const computerWidth =
            isdisplayPrizeLevelsOnItemDetails && prizeStructure.length > 0
                ? { c1: 5, c2: 6, c3: 4 }
                : { c1: 8, c2: 8, c3: 8 };
        const tabletWidth =
            isdisplayPrizeLevelsOnItemDetails && prizeStructure.length > 0
                ? { c1: 16, c2: 8, c3: 7 }
                : { c1: 8, c2: 8, c3: 8 };

        const modalWidth =
            prizeStructure.length > 0 && windowWidth >= 992 ? 1000 : 700;
        return (
            <Modal
                open={isOpen}
                onMount={this.handleMount}
                className="game-detail-modal "
                name="gameCatalogDetailModal"
                data-testid="gameCatalogDetailModal"
                style={{ width: modalWidth }}>
                <Modal.Content>
                    <span
                        className="icon-Close static-close-button"
                        onClick={this.handleClose}
                    />
                    <Grid className="game-detail-grid">
                        <Grid.Column
                            computer={computerWidth.c1}
                            tablet={tabletWidth.c1}
                            mobile={16}>
                            <h3
                                className={'text-center'}
                                style={{
                                    color: game?.colourCode,
                                }}>
                                {game?.highlightName}
                            </h3>
                            <div style={gameDetailModalHighlightStyle(game)}>
                                {game.image}
                            </div>
                        </Grid.Column>
                        <Grid.Column
                            computer={computerWidth.c2}
                            tablet={tabletWidth.c2}
                            mobile={16}>
                            <Header className="title-text bold game-title mb-2">
                                {game.gameRefAndName}
                            </Header>
                            {isInstantTicket && (
                                <div className={'mb-2'}>
                                    <p>
                                        {`${localizeDetail.themeName}: `}
                                        <b>{game.themeName}</b>
                                    </p>
                                </div>
                            )}
                            <Grid columns={2} className={'pb-2 mb-0'}>
                                <GridRow children={2}>
                                    <GridColumn>
                                        <Icon className="icon-Ticket" />
                                        <span>
                                            {`${isInstantTicket
                                                ? localizeDetail.ticketsPerPack
                                                : localizeDetail.ticketsPerDeal
                                                }`}
                                        </span>
                                        <div className="bold ticket-price text-center">
                                            <span>{game.ticketPerDeal}</span>
                                        </div>
                                    </GridColumn>
                                    <GridColumn className={'text-center pt-2'}>
                                        <span>
                                            {`${localizeDetail.ticketPrice}`}
                                        </span>
                                        <div className="bold ticket-price text-center">
                                            <span className="bold">
                                                {formatMoney(game.ticketPrice)}
                                            </span>
                                        </div>
                                    </GridColumn>
                                </GridRow>
                                <GridRow
                                    className={
                                        'game-info-inner-wrapper m-3 mt-0'
                                    }>
                                    <GridColumn className={'text-align-s'}>
                                        <span>
                                            {isInstantTicket
                                                ? `${localizeDetail.packValue}`
                                                : `${localizeDetail.totalRevenue}`}
                                        </span>
                                    </GridColumn>
                                    <GridColumn className={'text-align-e'}>
                                        <span className="bold">
                                            {formatMoney(
                                                game.ticketPerDeal *
                                                game.ticketPrice,
                                            )}
                                        </span>
                                    </GridColumn>
                                    {!isInstantTicket && (
                                        <GridColumn className={'text-align-s'}>
                                            <span>
                                                {`${localizeDetail.totalPayout}`}
                                            </span>
                                        </GridColumn>
                                    )}
                                    {!isInstantTicket && (
                                        <GridColumn className={'text-align-e'}>
                                            <span className="bold">
                                                {formatMoney(
                                                    game.ticketPerDeal *
                                                    game.ticketPrice *
                                                    game.payout,
                                                )}
                                            </span>
                                        </GridColumn>
                                    )}
                                    {/* RE-1489  hiding commission calculation field for TC */}
                                    {!isInstantTicket && (
                                        <GridColumn className={'text-align-s'}>
                                            <span>
                                                {`${localizeDetail.commission}`}
                                            </span>
                                        </GridColumn>
                                    )}
                                    {!isInstantTicket && (
                                        <GridColumn className={'text-align-e'}>
                                            <span className="bold">
                                                {formatMoney(game.commission)}
                                            </span>
                                        </GridColumn>
                                    )}
                                </GridRow>
                                <GridRow
                                    className={
                                        'game-info-inner-wrapper m-3 mt-1 p-1'
                                    }>
                                    <GridColumn>
                                        <div className={'image-wrapper'}>
                                            <Image
                                                src={moneyImage}
                                                alt="money-image"
                                            />
                                        </div>
                                    </GridColumn>
                                    <GridColumn className={'display-table'}>
                                        <div
                                            className={
                                                'text-center  display-table-cell vertical-align-middle'
                                            }>
                                            <div
                                                className={'width-fit-content'}>
                                                <span>
                                                    {isInstantTicket
                                                        ? `${localizeDetail.maxPrize}`
                                                        : `${localizeDetail.retailCost}`}
                                                </span>
                                                <div className={'text-center'}>
                                                    <span className="bold  ">
                                                        {formatMoney(
                                                            isInstantTicket
                                                                ? game.maxPrize
                                                                : game.retailPrice,
                                                        )}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </GridColumn>
                                </GridRow>
                            </Grid>
                            <QuantityActionWrapper
                                variant="desktop"
                                showDetail={showDetail}
                                orderQty={orderQty}
                                incrementQuantity={incrementQuantity}
                                decrementQuantity={decrementQuantity}
                                game={game}
                                impersonateRetailer={impersonateRetailer}
                                gameInCart={gameInCart}
                                readOnly={readOnly}
                                gameInCartQty={gameInCartQty}
                                localizeDetail={localizeDetail}
                                handleAddToCart={this.handleAddToCart}
                                isEditOrder={isEditOrder}
                                showQuantity={showQuantity}
                                showSuggestedQty={showSuggestedQty}
                            />
                        </Grid.Column>

                        {isdisplayPrizeLevelsOnItemDetails &&
                            prizeStructure.length > 0 && (
                                <Grid.Column
                                    computer={computerWidth.c3}
                                    tablet={tabletWidth.c3}
                                    mobile={16}
                                    className="display-prize-structure-column">
                                    <Grid
                                        columns={2}
                                        className="prize-structure">
                                        <Grid.Row children={2}>
                                            <Grid.Column>
                                                <Grid.Column
                                                    textAlign="right"
                                                    className="bold">
                                                    {'Prize Level'}
                                                </Grid.Column>
                                                {prizeStructure.map((item) => (
                                                    <Grid.Column textAlign="right">
                                                        {formatMoney(
                                                            item.prizeLevel,
                                                        )}
                                                    </Grid.Column>
                                                ))}
                                            </Grid.Column>
                                            <GridColumn textAlign="center">
                                                <GridColumn className="bold ">
                                                    {'#Winners'}
                                                </GridColumn>
                                                {prizeStructure.map((item) => (
                                                    <Grid.Column textAlign="center">
                                                        {item.winners}
                                                    </Grid.Column>
                                                ))}
                                            </GridColumn>
                                        </Grid.Row>
                                    </Grid>{' '}
                                </Grid.Column>
                            )}

                        <QuantityActionWrapper
                            variant="mobile"
                            showDetail={showDetail}
                            orderQty={orderQty}
                            incrementQuantity={incrementQuantity}
                            decrementQuantity={decrementQuantity}
                            game={game}
                            impersonateRetailer={impersonateRetailer}
                            gameInCart={gameInCart}
                            readOnly={readOnly}
                            gameInCartQty={gameInCartQty}
                            localizeDetail={localizeDetail}
                            handleAddToCart={this.handleAddToCart}
                            isEditOrder={isEditOrder}
                            showQuantity={showQuantity}
                            showSuggestedQty={showSuggestedQty}
                        />
                    </Grid>
                </Modal.Content>
            </Modal>
        );
    }
}

const mapStateToProps = (
    {
        orderQuantity: { qty },
        cart: { orderedItems },
        organization: { configs },
        orderDetail: { orderedItems: orderDetailItems },
        retailerSelect: { impersonateRetailer },
    },
    { gameInCartQty },
) => {
    return {
        orderQty: qty,
        gameInCart: gameInCartQty,
        orderDetailItems,
        isInstantTicket:
            find(configs, { name: 'instant-ticket-view' })?.value === 'true',
        impersonateRetailer,
        isdisplayPrizeLevelsOnItemDetails:
            find(configs, { name: 'display-prize-levels-on-item-details' })
                ?.value === 'true',
    };
};

const mapDispatchToProps = (dispatch, { game, isEditOrder }) => {
    return {
        incrementQuantity: () => dispatch(incrementQuantity(game)),
        decrementQuantity: () => dispatch(decrementQuantity(game)),
        initOrderQuantity: () => dispatch(initOrderQuantity(game)),
        addToCart: () =>
            dispatch(isEditOrder ? addToOrder(game) : addToCart(game)),
        saveOrderQuantity: (qty) => dispatch(saveOrderQuantity(qty)),
        incrementGameQuantityForOrder: () =>
            dispatch(incrementGameQuantityForOrder(game)),
        decrementGameQuantityForOrder: () =>
            dispatch(decrementGameQuantityForOrder(game)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(GameCatalogDetailModal);
